import { render, staticRenderFns } from "./GClassManagementTrendAnalysisPsychologicalSafety.vue?vue&type=template&id=3dbc60a1&scoped=true&"
import script from "./GClassManagementTrendAnalysisPsychologicalSafety.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementTrendAnalysisPsychologicalSafety.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc60a1",
  null
  
)

export default component.exports